import type { ScreenId } from './screen.constant';

/** 화면 이름(screens.md 1절, DD-14 Q11). BackBar 글자도 이것이다(DD-16 C14) */
export const SCREEN_TITLE: Record<ScreenId, string> = {
  S01: '로그인',
  S02: '비밀번호 찾기',
  S03: '비밀번호 재설정',
  S04: '메인',
  S05: '펀드 상세',
  S06: '펀드 추가',
  S07: '펀드 수정',
  S08: '포트폴리오 상세',
  S09: '포트폴리오 추가',
  S10: '포트폴리오 정보 수정',
  S11: '분기 데이터 입력',
  S12: '캡테이블',
  S13: '리포트 공개 관리',
  S14: '포트폴리오 평가',
  S15: '파일 관리',
  S16: '계정 관리',
  S17: '예약 메일 설정',
  S18: '정보 수정',
  S19: '환율 정보',
  S20: '사용자 접속 로그',
  S21: '페이지 없음',
  S22: '앱 시작 · 서버 연결 실패',
};
